import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-fv-right',
  templateUrl: './fv-right.component.html',
  styleUrls: ['./fv-right.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, NgClass, TranslatePipe]
})
export class FvRightComponent {
  @Input() image: string;
  @Input() text: { headline: string; text: string };
  readonly needsColumn = input(false);
  readonly maxHeight = input('calc(100vh - 210px)');
  readonly imageMaxWidth = input('350px');
}
